// extracted by mini-css-extract-plugin
export default {"container":"Register_container__wt9vH"};